/** Prefix for client-generated karaoke signup QR payloads (version 1). */
export const KARAOKE_SIGNUP_QR_PREFIX = "jukebox:karaoke:1:";

/** Matches backend TokenService TTL (15 minutes). */
export const KARAOKE_SIGNUP_TTL_SECONDS = 15 * 60;

/**
 * Build a QR payload for karaoke signup. No server call required.
 * Admin staff verify the payload via POST /api/karaoke/signup/verify.
 */
export function buildKaraokeSignupQrPayload({ eventId, songId, performerName }) {
  const payload = {
    eventId,
    songId,
    performerName: performerName.trim(),
    iat: Math.floor(Date.now() / 1000)
  };
  const json = JSON.stringify(payload);
  const b64 = base64UrlEncode(json);
  return `${KARAOKE_SIGNUP_QR_PREFIX}${b64}`;
}

/** Expiry time for display (iat + TTL). */
export function karaokeSignupExpiresAt(iatSeconds) {
  return new Date((iatSeconds + KARAOKE_SIGNUP_TTL_SECONDS) * 1000);
}

function base64UrlEncode(str) {
  const bytes = new TextEncoder().encode(str);
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
